import { SPECIES_IDS, type SpeciesId } from "../sim/species";

/** Non-dominant-hand seed pouch: which of the 4 species is selected. */
export class SeedPouch {
  private index = 0;
  private readonly listeners: ((id: SpeciesId) => void)[] = [];

  get species(): SpeciesId {
    return SPECIES_IDS[this.index]!;
  }
  get speciesIndex(): number {
    return this.index;
  }

  cycle(dir: 1 | -1): void {
    this.index = (this.index + dir + SPECIES_IDS.length) % SPECIES_IDS.length;
    for (const l of this.listeners) l(this.species);
  }
  select(index: number): void {
    this.index = ((index % SPECIES_IDS.length) + SPECIES_IDS.length) % SPECIES_IDS.length;
    for (const l of this.listeners) l(this.species);
  }
  /** Subscribe to seed changes; returns an unsubscribe fn. Fires once immediately. */
  onChange(l: (id: SpeciesId) => void): () => void {
    this.listeners.push(l);
    l(this.species);
    return () => {
      const i = this.listeners.indexOf(l);
      if (i >= 0) this.listeners.splice(i, 1);
    };
  }
}

/** Sink for planting actions — sends a seed to the sim (which then owns growth). */
export interface Planter {
  plant(species: SpeciesId, x: number, z: number): void;
}
